const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      Made with ♥ by{" "}
      <a
        href="https://github.com/bilalmirza74"
        style={{ cursor: "pointer" }}
      >
        Bilal Mirza
      </a>
    </div>
  );
};

export default Footer;
